( function( $ ) {
	'use strict';

	$( function() {

		$(document).ready(function () {
			$('a[href^="#"]').each(function () {
				$(this).on('click', function (e) {
					if ( !$(this).hasClass('skip') ) {
						e.preventDefault();
					}

					let href = $(this).attr('href');
					let anchorTop = $(href).offset().top;

					$('html, body').animate({
						scrollTop: anchorTop
					}, 500);
				});
			});
		});
		
	} );
})(jQuery, document);